export default __webpack_public_path__ + "static/media/HARYANA-5.ef910c97.webp";